// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { FaDownload, FaCalendarAlt, FaSearch, FaRedo, FaSignOutAlt, FaFilePdf, FaFileExcel, FaTimes } from 'react-icons/fa';
// import * as XLSX from 'xlsx'; // Only kept Excel, removed jsPDF/html2canvas
// import './Prapt_Aai.css'; 
// import './AnnualReport.css'; 
// import topLogo from './logo-placeholder.png'; 

// const AnnualReport = () => {
//     const navigate = useNavigate();
    
//     // --- State ---
//     const [fromDate, setFromDate] = useState('');
//     const [toDate, setToDate] = useState('');
//     const [showDownloadMenu, setShowDownloadMenu] = useState(false); 
//     const [isLoading, setIsLoading] = useState(false);
    
//     const [reportData, setReportData] = useState({
//         totalIncome: 0,
//         totalExpense: 0,
//         balance: 0,
//         transactions: [], 
//         isSearched: false
//     });

//     // --- Handlers ---
//     const handleLogout = () => {
//         if(window.confirm("Do you want to Sign Out?")) {
//             localStorage.clear();
//             navigate('/'); 
//         }
//     };

//     const handleSearch = async (e) => {
//         e.preventDefault();
//         if (!fromDate || !toDate) return;
        
//         setIsLoading(true);
//         try {
//             const response = await fetch('/api/dashboard/annual-report-search', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({ fromDate, toDate }),
//             });
//             const result = await response.json();
            
//             if (result.success) {
//                 setReportData({
//                     totalIncome: result.totalIncome || 0,
//                     totalExpense: result.totalExpense || 0,
//                     balance: result.balance || 0,
//                     transactions: result.transactions || [], 
//                     isSearched: true
//                 });
//             } else {
//                 alert("Error: " + result.message);
//             }
//         } catch (error) {
//             alert("Server Connection Error");
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     const handleReset = () => {
//         setFromDate(''); setToDate('');
//         setReportData({ totalIncome: 0, totalExpense: 0, balance: 0, transactions: [], isSearched: false });
//     };

//     const formatDate = (isoString) => {
//         if (!isoString) return "-";
//         return new Date(isoString).toLocaleDateString('en-GB'); // DD/MM/YYYY
//     };

//     // ==========================================
//     //  SIMPLIFIED PDF EXPORT (Native Print)
//     // ==========================================
//     const handleDownloadPDF = () => {
//         setShowDownloadMenu(false);
//         window.print(); // Simple, crisp, and clean! CSS handles the rest.
//     };

//    // ==========================================
//     //  EXCEL EXPORT 
//     // ==========================================
//     const handleDownloadExcel = () => {
//         if (!reportData.isSearched || reportData.transactions.length === 0) return;

//         const excelData = reportData.transactions.map((item, index) => {
//             const isIncome = item.jama_rashi && item.jama_rashi > 0;
//             const isExpense = item.nikali_rashi && item.nikali_rashi > 0;

//             return {
//                 "S.No": index + 1,
//                 "दिनांक": formatDate(item.date),
//                 "रसीद न.": isIncome ? (item.rasid_no || "-") : "-",
//                 "नाम (Name)": item.name || "-",   // <--- दोनों के लिए सिर्फ एक कॉलम
//                 "आय का विवरण": isIncome ? (item.aai_ka_vivran || "-") : "-",
//                 "आय राशि": isIncome ? Number(item.jama_rashi) : 0,
//                 "वाउचर  न.": isExpense ? (item.voucher_no || "-") : "-",
//                 "व्यय का विवरण": isExpense ? (item.vyay_ka_vivran || "-") : "-",
//                 "खर्च राशि": isExpense ? Number(item.nikali_rashi) : 0,
//             };
//         });

//         const worksheet = XLSX.utils.json_to_sheet(excelData);
//         const workbook = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(workbook, worksheet, "Annual Report");
//         XLSX.writeFile(workbook, `AnnualReport_${fromDate}_to_${toDate}.xlsx`);
//         setShowDownloadMenu(false);
//     };
    
//     return (
//         <div className="details-container">
//             {/* Background Shapes */}
//             <div className="shape shape-1"></div><div className="shape shape-2"></div><div className="shape shape-3"></div>
            
//             <button className="logout-btn hide-in-pdf" onClick={handleLogout}>
//                 <FaSignOutAlt /> <span>Sign Out</span>
//             </button>

//             <div className="brand-header">
//                 <img src={topLogo} alt="Logo" className="brand-logo" />
//                 <div className="brand-text">
//                     <h2>गायत्री परिवार</h2>
//                     <h3>अलीराजपुर</h3>
//                 </div>
//             </div>

//             {/* --- MAIN CARD --- */}
//             <div className="report-card-glass" style={{width: '95%', maxWidth: '1200px'}}> 
//                 <h2 className="page-title">वार्षिक रिपोर्ट (Annual Report)</h2>

//                 {/* SEARCH FORM (Hidden when printing PDF) */}
//                 <form className="search-section hide-in-pdf" onSubmit={handleSearch}>
//                     <div className="date-input-group">
//                         <label>From Date (दिनांक से)</label>
//                         <div className="input-wrapper">
//                             <FaCalendarAlt className="input-icon" />
//                             <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} required/>
//                         </div>
//                     </div>
//                     <div className="date-input-group">
//                         <label>To Date (दिनांक तक)</label>
//                         <div className="input-wrapper">
//                             <FaCalendarAlt className="input-icon" />
//                             <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} required/>
//                         </div>
//                     </div>
//                     <div className="action-buttons-container">
//                         <button type="submit" className="action-btn btn-search" disabled={isLoading}>
//                             <FaSearch /> {isLoading ? "SEARCHING..." : "SEARCH"}
//                         </button>
//                         <button type="button" className="action-btn btn-reset" onClick={handleReset}>
//                             <FaRedo /> RESET
//                         </button>
//                     </div>
//                 </form>

//                 {/* SUMMARY BOX */}
//                 <div className="summary-card">
//                     <div className="summary-header"><h3>आय एवं व्यय राशि का विवरण</h3></div>
//                     <div className="summary-row">
//                         <span className="label">कुल प्राप्त राशि:</span>
//                         <span className="value val-green">{reportData.isSearched ? `₹ ${reportData.totalIncome}` : "---"}</span>
//                     </div>
//                     <div className="summary-row">
//                         <span className="label">कुल व्यय राशि:</span>
//                         <span className="value val-red">{reportData.isSearched ? `₹ ${reportData.totalExpense}` : "---"}</span>
//                     </div>
//                     <div className="summary-row row-total">
//                         <span className="label">शेष राशि:</span>
//                         <span className="value val-black">{reportData.isSearched ? `₹ ${reportData.balance}` : "---"}</span>
//                     </div>
//                 </div>

//                 {/* RESULTS TABLE */}
//                 {reportData.isSearched && !isLoading && (
//                     <div className="table-container">
//                         <h3 className="table-title">लेन-देन का विवरण (Transactions)</h3>

//                         <div className="table-summary-block">
//                             <p className="summary-text-line">
//                                 आय एवं व्यय का विवरण <strong>{formatDate(fromDate)}</strong> से <strong>{formatDate(toDate)}</strong> तक
//                             </p>
//                         </div> 

//                         <div className="table-responsive">
//                             <table className="report-table">
//                                 <thead>
//                                     <tr>
//                                         <th style={{minWidth: '50px'}}>S.No</th>
//                                         <th style={{minWidth: '100px'}}>दिनांक</th>
//                                         <th style={{minWidth: '80px'}}>रसीद नं</th>
//                                         <th style={{minWidth: '150px'}}>दानदाता का नाम</th>
//                                         <th style={{minWidth: '150px'}}>आय का विवरण</th>
//                                         <th style={{minWidth: '100px'}}>आय राशि</th>
//                                         <th style={{minWidth: '80px'}}>वाउचर नं</th>
//                                         <th style={{minWidth: '150px'}}>खर्च कर्ता का नाम</th>
//                                         <th style={{minWidth: '150px'}}>व्यय का विवरण</th>
//                                         <th style={{minWidth: '100px'}}>व्यय राशि</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {reportData.transactions.length > 0 ? (
//                                         reportData.transactions.map((item, index) => {
//                                             const isIncome = item.jama_rashi && item.jama_rashi > 0;
//                                             const isExpense = item.nikali_rashi && item.nikali_rashi > 0;
//                                             return (
//                                                 <tr key={index}>
//                                                     <td>{index + 1}</td>
//                                                     <td>{formatDate(item.date)}</td>
//                                                     <td>{isIncome ? (item.rasid_no || "-") : "-"}</td>
//                                                     <td>{isIncome ? item.name : "-"}</td>
//                                                     <td>{isIncome ? (item.aai_ka_vivran || "-") : "-"}</td>
//                                                     <td className="text-green-bold">{isIncome ? `₹${item.jama_rashi}` : "-"}</td>
//                                                     <td>{isExpense ? (item.voucher_no || "-") : "-"}</td>
//                                                     <td>{isExpense ? item.name : "-"}</td>
//                                                     <td>{isExpense ? (item.vyay_ka_vivran || "-") : "-"}</td>
//                                                     <td className="text-red-bold">{isExpense ? `₹${item.nikali_rashi}` : "-"}</td>
//                                                 </tr>
//                                             );
//                                         })
//                                     ) : (
//                                         <tr>
//                                             <td colSpan="10" style={{textAlign: 'center', padding: '20px', color: '#666'}}>
//                                                 कोई लेन-देन नहीं मिला (No transactions found).
//                                             </td>
//                                         </tr>
//                                     )}
//                                 </tbody>
//                             </table>
//                         </div>
//                     </div>
//                 )}
//             </div>
            
//             {/* FLOATING DOWNLOAD MENU */}
//             {reportData.isSearched && !isLoading && reportData.transactions.length > 0 && (
//                 <>
//                     <div className={`download-options hide-in-pdf ${showDownloadMenu ? 'show' : ''}`}>
//                         <button className="dl-option-btn pdf-btn" onClick={handleDownloadPDF}><FaFilePdf /> PDF</button>
//                         <button className="dl-option-btn excel-btn" onClick={handleDownloadExcel}><FaFileExcel /> Excel</button>
//                     </div>
//                     <button className="fab-download-btn hide-in-pdf" onClick={() => setShowDownloadMenu(!showDownloadMenu)}>
//                         {showDownloadMenu ? <FaTimes /> : <FaDownload />}
//                     </button>
//                 </>
//             )}
//         </div>
//     );
// };

// export default AnnualReport;


import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
    FaSearch, FaRedo, FaSignOutAlt, FaCalendarAlt, 
    FaDownload, FaFilePdf, FaFileExcel, FaTimes, FaFileAlt, FaArrowLeft
} from 'react-icons/fa';
import * as XLSX from 'xlsx'; 
import './AnnualReport.css';

import topLogo from './logo-placeholder.png'; 

const AnnualReport = () => {
    const navigate = useNavigate();
    
    // --- State ---
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [showDownloadMenu, setShowDownloadMenu] = useState(false); 
    const [isLoading, setIsLoading] = useState(false);
    
    const [reportData, setReportData] = useState({
        totalIncome: 0,
        totalExpense: 0,
        balance: 0,
        transactions: [], 
        isSearched: false
    });

    // --- Handlers ---
    const handleLogout = () => {
        if(window.confirm("Do you want to Sign Out?")) {
            localStorage.clear();
            navigate('/'); 
        }
    };

    const handleSearch = async (e) => {
        e.preventDefault();
        if (!fromDate || !toDate) {
            alert("कृपया दिनांक से और दिनांक तक का चयन करें। (Please select both dates.)");
            return;
        }
        
        setIsLoading(true);
        try {
            const response = await fetch('/api/dashboard/annual-report-search', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ fromDate, toDate }),
            });
            const result = await response.json();
            
            if (result.success) {
                setReportData({
                    totalIncome: result.totalIncome || 0,
                    totalExpense: result.totalExpense || 0,
                    balance: result.balance || 0,
                    transactions: result.transactions || [], 
                    isSearched: true
                });
            } else {
                alert("Error: " + result.message);
                handleReset();
            }
        } catch (error) {
            alert("Server Connection Error");
        } finally {
            setIsLoading(false);
        }
    };

    const handleReset = () => {
        setFromDate(''); 
        setToDate('');
        setReportData({ totalIncome: 0, totalExpense: 0, balance: 0, transactions: [], isSearched: false });
        setShowDownloadMenu(false);
    };

    const formatDate = (isoString) => {
        if (!isoString) return "-";
        return new Date(isoString).toLocaleDateString('en-IN'); 
    };

    // ==========================================
    //  PDF & EXCEL EXPORT 
    // ==========================================
    const handleDownloadPDF = () => {
        setShowDownloadMenu(false);
        window.print(); 
    };

    const handleDownloadExcel = () => {
        if (!reportData.isSearched || reportData.transactions.length === 0) return;

        const excelData = reportData.transactions.map((item, index) => {
            const isIncome = item.jama_rashi && item.jama_rashi > 0;
            const isExpense = item.nikali_rashi && item.nikali_rashi > 0;

            return {
                "S.No": index + 1,
                "दिनांक": formatDate(item.date),
                "रसीद न.": isIncome ? (item.rasid_no || "-") : "-",
                "नाम (Name)": item.name || "-", 
                "आय का विवरण": isIncome ? (item.aai_ka_vivran || "-") : "-",
                "आय राशि": isIncome ? Number(item.jama_rashi) : 0,
                "वाउचर  न.": isExpense ? (item.voucher_no || "-") : "-",
                "व्यय का विवरण": isExpense ? (item.vyay_ka_vivran || "-") : "-",
                "खर्च राशि": isExpense ? Number(item.nikali_rashi) : 0,
            };
        });

        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Annual Report");
        XLSX.writeFile(workbook, `AnnualReport_${fromDate}_to_${toDate}.xlsx`);
        setShowDownloadMenu(false);
    };
    
    return (
        <div className="income-page-container">
            {/* --- TOP NAV BAR --- */}
            <div className="income-header-nav hide-in-pdf">
                <div className="income-brand" onClick={() => navigate("/home")} style={{ cursor: "pointer" }}>
                    <img src={topLogo} alt="Logo" className="income-logo" />
                    <div className="income-brand-text">
                        <h2>गायत्री परिवार</h2>
                        <h3>अलीराजपुर</h3>
                    </div>
                </div>
                <button className="income-logout-btn" onClick={handleLogout} title="Sign Out">
    <FaSignOutAlt size={18} /> 
    <span>Sign Out</span>
</button>
            </div>

            {/* --- MAIN CARD --- */}
            <div className="income-main-card">
                <button className="back-btn hide-in-pdf" onClick={() => navigate("/home")} style={{ marginBottom: '15px', background: 'none', border: 'none', color: '#4a148c', fontSize: '16px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <FaArrowLeft /> Back
                </button>

                <h2 
    className="income-card-title" 
    style={{ 
        textAlign: 'center', 
        color: '#4a148c', 
        fontWeight: 'bold', 
        fontSize: '24px', 
        marginBottom: '25px' 
    }}
>
    गायत्री परिवार अलीराजपुर वार्षिक रिपोर्ट
    {reportData.isSearched && ` दिनांक ${fromDate} से दिनांक ${toDate} तक`}
</h2>

                {/* SEARCH FORM */}
                <form className="hide-in-pdf" onSubmit={handleSearch}>
                    <div className="income-input-grid">
                        <div className="income-input-group">
                            <label>From Date (दिनांक से)</label>
                            <div className="income-input-wrapper">
                                <FaCalendarAlt className="input-icon" />
                                <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} required />
                            </div>
                        </div>

                        <div className="income-input-group">
                            <label>To Date (दिनांक तक)</label>
                            <div className="income-input-wrapper">
                                <FaCalendarAlt className="input-icon" />
                                <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} required />
                            </div>
                        </div>
                    </div>

                    <div className="income-btn-grid" style={{ marginTop: '20px' }}>
                        <button type="submit" className="income-action-btn search-btn" disabled={isLoading}>
                            <FaSearch /> {isLoading ? "SEARCHING..." : "SEARCH"}
                        </button>
                        <button type="button" className="income-action-btn reset-btn" onClick={handleReset}>
                            <FaRedo /> RESET
                        </button>
                    </div>
                </form>

                {/* --- PROGRESS BAR --- */}
                {isLoading && (
                    <div className="loader-wrapper" style={{ marginTop: '30px' }}>
                        <div className="loader-content">
                            <div className="premium-progress-container">
                                <div className="premium-progress-bar">
                                    <div className="premium-progress-shimmer"></div>
                                </div>
                            </div>
                            <div className="loading-status">
                                <span className="spinner-dot"></span>
                                <p>डाटा प्रोसेस हो रहा है... (Processing...)</p>
                            </div>
                        </div>
                    </div>
                )}

                {/* --- NO DATA FOUND --- */}
                {!isLoading && reportData.isSearched && reportData.transactions.length === 0 && (
                    <div className="no-data-card" style={{ marginTop: '30px' }}>
                        <div className="no-data-icon-box">
                            <FaSearch size={30} className="floating-icon" />
                        </div>
                        <h3>क्षमा करें, कोई लेन-देन नहीं मिला</h3>
                        <p>दिनांक <strong>{formatDate(fromDate)}</strong> से <strong>{formatDate(toDate)}</strong> के बीच कोई रिकॉर्ड दर्ज नहीं है।</p>
                    </div>
                )}

                {/* --- RESULTS AREA --- */}
                {!isLoading && reportData.isSearched && reportData.transactions.length > 0 && (
                    <div className="income-results-area" style={{ marginTop: '30px' }}>
                        
                        {/* BIG HIGHLIGHT PILLS */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '15px', flexWrap: 'wrap', marginBottom: '20px' }}>
                            <div style={{ flex: 1, minWidth: '150px', background: '#e8f5e9', border: '1px solid #4caf50', borderRadius: '10px', padding: '15px', textAlign: 'center' }}>
                                <h4 style={{ margin: 0, color: '#2e7d32', fontSize: '14px' }}>कुल आय (Total Income)</h4>
                                <h2 style={{ margin: '5px 0 0 0', color: '#1b5e20' }}>₹ {reportData.totalIncome}</h2>
                            </div>
                            <div style={{ flex: 1, minWidth: '150px', background: '#ffebee', border: '1px solid #f44336', borderRadius: '10px', padding: '15px', textAlign: 'center' }}>
                                <h4 style={{ margin: 0, color: '#c62828', fontSize: '14px' }}>कुल खर्च (Total Expense)</h4>
                                <h2 style={{ margin: '5px 0 0 0', color: '#b71c1c' }}>₹ {reportData.totalExpense}</h2>
                            </div>
                            <div style={{ flex: 1, minWidth: '150px', background: '#e3f2fd', border: '1px solid #2196f3', borderRadius: '10px', padding: '15px', textAlign: 'center' }}>
                                <h4 style={{ margin: 0, color: '#1565c0', fontSize: '14px' }}>शेष राशि (Net Balance)</h4>
                                <h2 style={{ margin: '5px 0 0 0', color: '#0d47a1' }}>₹ {reportData.balance}</h2>
                            </div>
                        </div>

                        <hr className="results-divider" />

                        {/* TABLE */}
                        <div className="table-responsive">
                            <table className="income-clean-table">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>दिनांक</th>
                                        <th>रसीद नं</th>
                                        <th>नाम</th>
                                        <th>आय का विवरण</th>
                                        <th style={{ color: '#2e7d32' }}>आय राशि</th>
                                        <th>वाउचर नं</th>
                                        <th>व्यय का विवरण</th>
                                        <th style={{ color: '#c62828' }}>व्यय राशि</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {reportData.transactions.map((item, index) => {
                                        const isIncome = item.jama_rashi && item.jama_rashi > 0;
                                        const isExpense = item.nikali_rashi && item.nikali_rashi > 0;
                                        return (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{formatDate(item.date)}</td>
                                                <td>{isIncome ? (item.rasid_no || "-") : "-"}</td>
                                                <td>{item.name || "-"}</td>
                                                <td>{isIncome ? (item.aai_ka_vivran || "-") : "-"}</td>
                                                <td style={{ color: '#2e7d32', fontWeight: 'bold' }}>{isIncome ? `₹${item.jama_rashi}` : "-"}</td>
                                                <td>{isExpense ? (item.voucher_no || "-") : "-"}</td>
                                                <td>{isExpense ? (item.vyay_ka_vivran || "-") : "-"}</td>
                                                <td style={{ color: '#c62828', fontWeight: 'bold' }}>{isExpense ? `₹${item.nikali_rashi}` : "-"}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>

           {/* FLOATING DOWNLOAD MENU */}
{reportData.isSearched && !isLoading && reportData.transactions.length > 0 && (
    <div className="hide-in-pdf">
        <div className={`download-options ${showDownloadMenu ? 'show' : ''}`} style={{ position: 'fixed', bottom: '95px', right: '32px', display: showDownloadMenu ? 'flex' : 'none', flexDirection: 'column', gap: '12px', alignItems: 'center' }}>
            <button onClick={handleDownloadPDF} title="Download PDF" style={{ width: '50px', height: '50px', borderRadius: '50%', background: '#f44336', color: 'white', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 8px rgba(0,0,0,0.3)' }}>
                <FaFilePdf size={22} />
            </button>
            <button onClick={handleDownloadExcel} title="Download Excel" style={{ width: '50px', height: '50px', borderRadius: '50%', background: '#4caf50', color: 'white', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 8px rgba(0,0,0,0.3)' }}>
                <FaFileExcel size={22} />
            </button>
        </div>
        
        <button 
            className="fab-download-btn" 
            onClick={() => setShowDownloadMenu(!showDownloadMenu)}
            style={{ zIndex: 1000 }}
        >
            {showDownloadMenu ? <FaTimes /> : <FaDownload />}
        </button>
    </div>
)}
        </div>
    );
};

export default AnnualReport;